import { render, staticRenderFns } from "./openLabour.vue?vue&type=template&id=55911c14&scoped=true&"
import script from "./openLabour.vue?vue&type=script&lang=js&"
export * from "./openLabour.vue?vue&type=script&lang=js&"
import style0 from "./openLabour.vue?vue&type=style&index=0&id=55911c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55911c14",
  null
  
)

export default component.exports